import React, { useEffect, useState } from "react";
import { updatePlayerAttribute } from "../firebase/fireFuncs";
import { saveMoodInHistory } from "../history/historyFuncs";
import { getTimeDiff } from "../misc/helperfuncs";
import activeStore from "../stores/activeStore";
import MainStore from "../stores/MainStore";
import useHandlePlayerArrays from "./useHandlePlayerArrays";

const makeMood = (type) => {
  return {
    activities: [],
    goals: [],
    focuses: [],
    started: Date.now(),
    ended: null,
    type,
  };
};

const useHandleActiveBox = () => {
  const [timePassed, setTimePassed] = useState({ seconds: 0, minutes: 0 });
  const { findObjectById, updateObject } = useHandlePlayerArrays();
  const { player, tick } = MainStore();
  const { setActive, box } = activeStore();

  function combineMoods(openObject, completed) {
    // combine the moods of the open object with the active moods like in combineActiveRatings
    const moods = { open: openObject.moods, active: box.moods };
    console.log("");
    const newMoods = {
      angry: 0,
      sad: 0,
      happy: 0,
      productive: 0,
      confused: 0,
      exhausted: 0,
    };
    const states = [
      "happy",
      "productive",
      "exhausted",
      "angry",
      "confused",
      "sad",
    ];
    for (let i = 0; i < states.length; i++) {
      const state = states[i];
      newMoods[state] = moods.open[state] + moods.active[state];
    }
    const newOpen = { ...openObject, moods: newMoods };
    newOpen.completed = completed;

    // update the time in the open object
    newOpen.minutes.active += timePassed.minutes;
    setTimePassed({ seconds: 0, minutes: 0 });
    updateObject("open", newOpen);
    resetActiveObject();
  }

  function resetActiveObject() {
    setActive(null);
    updatePlayerAttribute(player.uid, "active", {
      ...player.active,
      box: null,
    });
  }

  function combineActiveRatings(objects, completed) {
    const numbers = [1, 2, 3, 4, 5];
    const ratings = {
      open: {
        first: objects.open.rating.active.first,
        second: objects.open.rating.active.second,
      },
      active: { first: box.ratings.first, second: box.ratings.second },
    };

    const newRatings = {
      active: {
        first: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
        second: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
      },
    };
    // combine the numbers values of the open objects in ratings with the active number values in ratings in a new object
    for (let i = 0; i < numbers.length; i++) {
      const number = numbers[i];
      newRatings.active.first[number] =
        ratings.open.first[number] + ratings.active.first[number];
      newRatings.active.second[number] =
        ratings.open.second[number] + ratings.active.second[number];
    }

    // update the open object with the new ratings
    const newOpen = {
      ...objects.open,
      rating: { ...objects.open.rating, active: newRatings.active },
    };
    combineMoods(newOpen, completed);
  }

  function stopActive(completed) {
    // combine active Ratings
    findObjectById(box.id, box.type, combineActiveRatings, completed);
  }

  // auto saved active every 2 minutes
  function synchronizeActive() {
    updatePlayerAttribute(player.uid, "active.box", box);
  }

  useEffect(() => {
    if (player?.active.box) {
      const timeDiff = getTimeDiff(player.active.box.date, Date.now());
      setTimePassed(timeDiff);
    }
    if (tick % 180 == 0 && box && tick > 0) {
      synchronizeActive();
    }
  }, [tick]);

  function placeNewActiveBox(active) {
    setActive(active, "box");
    updatePlayerAttribute(player.uid, "active.box", active);
  }

  function onRatingTick(ratingObj, field) {
    const newActive = {
      ...box,
      ratings: { ...box.ratings, [field]: ratingObj },
    };
    setActive(newActive, "box");
  }

  function updateActiveBoxMoods(mood) {
    const newActive = {
      ...box,
      moods: { ...box?.moods, [mood]: box.moods[mood] + 5 },
    };
    setActive(newActive, "box");
  }

  // increase Mood for active box
  useEffect(() => {
    if (player && box) {
      if (tick % 5 == 0) updateActiveBoxMoods(player.active.mood?.type);
    }
  }, [tick]);

  function setActiveMood(mood) {
    const lastMood = player.active.mood;
    if (lastMood) {
      saveMoodInHistory({ ...lastMood, ended: Date.now() }, player.uid);
    }
    updatePlayerAttribute(player.uid, "active.mood", makeMood(mood));
  }

  return {
    placeNewActiveBox,
    timePassed,
    onRatingTick,
    updateActiveBoxMoods,
    stopActive,
    setActiveMood,
  };
};

export default useHandleActiveBox;
